import { Directive, TemplateRef } from "@angular/core";

/**
 * Directive to mark a template as row detail content.
 * Usage: <ng-template appTableRowDetailsTemplate let-row>
 *   ... detail content for the row ...
 * </ng-template>
 */
@Directive({
  selector: "[appTableRowDetailsTemplate]",
  standalone: true,
})
export class TableRowDetailsTemplateDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
